/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import {
  Icon,
  icoAdd16,
  icoAdd24,
  icoAdd32,
  icoAddCircle16,
  icoAddCircle24,
  icoAddCircle32,
  icoAddfolder16,
  icoAddfolder24,
  icoAddfolder32,
  icoAlert16,
  icoAlert24,
  icoAlert32,
  icoAlertDark16,
  icoAlertDark24,
  icoAlertDark32,
  icoApplist16,
  icoApplist24,
  icoApplist32,
  icoArrowDown16,
  icoArrowDown24,
  icoArrowDown32,
  icoArrowUp16,
  icoArrowUp24,
  icoArrowUp32,
  icoBrightness16,
  icoBrightness24,
  icoBrightness32,
  icoCalendar16,
  icoCalendar24,
  icoCalendar32,
  icoCaretDown16,
  icoCaretDown24,
  icoCaretDown32,
  icoCaretLeft16,
  icoCaretLeft24,
  icoCaretLeft32,
  icoCaretRight16,
  icoCaretRight24,
  icoCaretRight32,
  icoCaretUp16,
  icoCaretUp24,
  icoCaretUp32,
  icoCheckboxComponent16,
  icoCheckboxComponent24,
  icoCheckmark16,
  icoCheckmark24,
  icoCheckmark32,
  icoCheckmarkCircle16,
  icoCheckmarkCircle24,
  icoCheckmarkCircle32,
  icoClock16,
  icoClock24,
  icoClock32,
  icoClose16,
  icoClose24,
  icoClose32,
  icoDatabaseRemove16,
  icoDatabaseRemove24,
  icoDatabaseRemove32,
  icoDisplaySettings16,
  icoDisplaySettings24,
  icoDisplaySettings32,
  icoDownload16,
  icoDownload24,
  icoDownload32,
  icoEdit16,
  icoEdit24,
  icoEdit32,
  icoError16,
  icoError24,
  icoError32,
  icoExamnote16,
  icoExamnote24,
  icoExamnote32,
  icoExchange16,
  icoExchange24,
  icoExchange32,
  icoExport16,
  icoExport24,
  icoExport32,
  icoFilter16,
  icoFilter24,
  icoFilter32,
  icoFlag16,
  icoFlag24,
  icoFlag32,
  icoFolder16,
  icoFolder24,
  icoFolder32,
  icoFormError16,
  icoFreezepane16,
  icoFreezepane24,
  icoFreezepane32,
  icoGeHealthcareStackedLogo,
  icoGeHealthcareStandardLogo,
  icoGelogo16,
  icoGelogo24,
  icoGelogo32,
  icoGrabMovePanelVertical16,
  icoGrabMovePanelVertical24,
  icoGrabMovePanelVertical32,
  icoHamburger16,
  icoHamburger24,
  icoHamburger32,
  icoImport16,
  icoImport24,
  icoImport32,
  icoInfo16,
  icoInfo24,
  icoInfo32,
  icoKey16,
  icoKey24,
  icoKey32,
  icoLanguage16,
  icoLanguage24,
  icoLanguage32,
  icoLayout3116,
  icoLayout3124,
  icoLayout3132,
  icoLink16,
  icoLink24,
  icoLink32,
  icoLock16,
  icoLock24,
  icoLock32,
  icoManufacturerIso32,
  icoMicrophone16,
  icoMicrophone24,
  icoMicrophone32,
  icoMonitor16,
  icoMonitor24,
  icoMonitor32,
  icoMoon16,
  icoMoon24,
  icoMoon32,
  icoMoreVertical16,
  icoMoreVertical24,
  icoMoreVertical32,
  icoNotes16,
  icoNotes24,
  icoNotes32,
  icoNotification16,
  icoNotification24,
  icoNotification32,
  icoOpenpanelLeft16,
  icoOpenpanelLeft24,
  icoOpenpanelLeft32,
  icoPin16,
  icoPin24,
  icoPin32,
  icoPlaceholderavatar16,
  icoPlaceholderavatar24,
  icoPlaceholderavatar32,
  icoPlus16,
  icoPlus24,
  icoPlus32,
  icoPlusminus16,
  icoPlusminus24,
  icoPlusminus32,
  icoPreview16,
  icoPreview24,
  icoPreview32,
  icoPreviewHide16,
  icoPreviewHide24,
  icoPreviewHide32,
  icoProtocolNeedsReviewed16,
  icoProtocolNeedsReviewed24,
  icoProtocolNeedsReviewed32,
  icoRefresh16,
  icoRefresh24,
  icoRefresh32,
  icoRemove16,
  icoRemove24,
  icoRemove32,
  icoReset16,
  icoReset24,
  icoReset32,
  icoSave16,
  icoSave24,
  icoSave32,
  icoSearch16,
  icoSearch24,
  icoSearch32,
  icoSettings16,
  icoSettings24,
  icoSettings32,
  icoShare16,
  icoShare24,
  icoShare32,
  icoSort16,
  icoSort24,
  icoSort32,
  icoStarFilled16,
  icoStarFilled24,
  icoStarFilled32,
  icoTrash16,
  icoTrash24,
  icoTrash32,
  icoUnlink16,
  icoUnlink24,
  icoUnlink32,
  icoUnlock16,
  icoUnlock24,
  icoUnlock32,
  icoUser16,
  icoGroup16,
  icoViewportsettings16,
  icoViewportsettings24,
  icoViewportsettings32,
  icoErrorDark16,
  icoErrorDark24,
  icoErrorDark32,
  icoEditUnavailable16,
  icoEditUnavailable24,
  icoEditUnavailable32,
  icoArrowLeft16,
  icoArrowLeft24,
  icoArrowLeft32,
  icoCircle16,
  icoAssignedToSelf16,
  icoAssignedToOther16,
  icoDictatingBySelf16,
  icoDictatingByOther16,
  icoDownloadUnavailable16,
  icoDownloadUnavailable24,
  icoDownloadUnavailable32,
  icoSpinner16,
  icoPatient16,
  icoPatient24,
  icoAi16,
  icoAi24,
  icoAi32,
  icoAiChat24
} from '@core/lib/icons';

export const icons: Icon[] = [
  icoAdd16,
  icoAdd24,
  icoAdd32,
  icoAddCircle16,
  icoAddCircle24,
  icoAddCircle32,
  icoAddfolder16,
  icoAddfolder24,
  icoAddfolder32,
  icoAi16,
  icoAi24,
  icoAi32,
  icoAlert16,
  icoAlert24,
  icoAlert32,
  icoAlertDark16,
  icoAlertDark24,
  icoAlertDark32,
  icoApplist16,
  icoApplist24,
  icoApplist32,
  icoArrowDown16,
  icoArrowDown24,
  icoArrowDown32,
  icoArrowUp16,
  icoArrowUp24,
  icoArrowUp32,
  icoArrowLeft16,
  icoArrowLeft24,
  icoArrowLeft32,
  icoBrightness16,
  icoBrightness24,
  icoBrightness32,
  icoCalendar16,
  icoCalendar24,
  icoCalendar32,
  icoCaretDown16,
  icoCaretDown24,
  icoCaretDown32,
  icoCaretLeft16,
  icoCaretLeft24,
  icoCaretLeft32,
  icoCaretRight16,
  icoCaretRight24,
  icoCaretRight32,
  icoCaretUp16,
  icoCaretUp24,
  icoCaretUp32,
  icoCheckboxComponent16,
  icoCheckboxComponent24,
  icoCheckmark16,
  icoCheckmark24,
  icoCheckmark32,
  icoCheckmarkCircle16,
  icoCheckmarkCircle24,
  icoCheckmarkCircle32,
  icoClock16,
  icoClock24,
  icoClock32,
  icoClose16,
  icoClose24,
  icoClose32,
  icoDatabaseRemove16,
  icoDatabaseRemove24,
  icoDatabaseRemove32,
  icoDisplaySettings16,
  icoDisplaySettings24,
  icoDisplaySettings32,
  icoDownload16,
  icoDownload24,
  icoDownload32,
  icoEdit16,
  icoEdit24,
  icoEdit32,
  icoError16,
  icoError24,
  icoError32,
  icoExamnote16,
  icoExamnote24,
  icoExamnote32,
  icoExchange16,
  icoExchange24,
  icoExchange32,
  icoExport16,
  icoExport24,
  icoExport32,
  icoFilter16,
  icoFilter24,
  icoFilter32,
  icoFlag16,
  icoFlag24,
  icoFlag32,
  icoFolder16,
  icoFolder24,
  icoFolder32,
  icoFormError16,
  icoFreezepane16,
  icoFreezepane24,
  icoFreezepane32,
  icoGeHealthcareStackedLogo,
  icoGeHealthcareStandardLogo,
  icoGelogo16,
  icoGelogo24,
  icoGelogo32,
  icoGrabMovePanelVertical16,
  icoGrabMovePanelVertical24,
  icoGrabMovePanelVertical32,
  icoHamburger16,
  icoHamburger24,
  icoHamburger32,
  icoImport16,
  icoImport24,
  icoImport32,
  icoInfo16,
  icoInfo24,
  icoInfo32,
  icoKey16,
  icoKey24,
  icoKey32,
  icoLanguage16,
  icoLanguage24,
  icoLanguage32,
  icoLayout3116,
  icoLayout3124,
  icoLayout3132,
  icoLink16,
  icoLink24,
  icoLink32,
  icoLock16,
  icoLock24,
  icoLock32,
  icoManufacturerIso32,
  icoMicrophone16,
  icoMicrophone24,
  icoMicrophone32,
  icoMonitor16,
  icoMonitor24,
  icoMonitor32,
  icoMoon16,
  icoMoon24,
  icoMoon32,
  icoMoreVertical16,
  icoMoreVertical24,
  icoMoreVertical32,
  icoNotes16,
  icoNotes24,
  icoNotes32,
  icoNotification16,
  icoNotification24,
  icoNotification32,
  icoOpenpanelLeft16,
  icoOpenpanelLeft24,
  icoOpenpanelLeft32,
  icoPin16,
  icoPin24,
  icoPin32,
  icoPlaceholderavatar16,
  icoPlaceholderavatar24,
  icoPlaceholderavatar32,
  icoPlus16,
  icoPlus24,
  icoPlus32,
  icoPlusminus16,
  icoPlusminus24,
  icoPlusminus32,
  icoPreview16,
  icoPreview24,
  icoPreview32,
  icoPreviewHide16,
  icoPreviewHide24,
  icoPreviewHide32,
  icoProtocolNeedsReviewed16,
  icoProtocolNeedsReviewed24,
  icoProtocolNeedsReviewed32,
  icoRefresh16,
  icoRefresh24,
  icoRefresh32,
  icoRemove16,
  icoRemove24,
  icoRemove32,
  icoReset16,
  icoReset24,
  icoReset32,
  icoSave16,
  icoSave24,
  icoSave32,
  icoSearch16,
  icoSearch24,
  icoSearch32,
  icoSettings16,
  icoSettings24,
  icoSettings32,
  icoShare16,
  icoShare24,
  icoShare32,
  icoSort16,
  icoSort24,
  icoSort32,
  icoStarFilled16,
  icoStarFilled24,
  icoStarFilled32,
  icoTrash16,
  icoTrash24,
  icoTrash32,
  icoUnlink16,
  icoUnlink24,
  icoUnlink32,
  icoUnlock16,
  icoUnlock24,
  icoUnlock32,
  icoUser16,
  icoGroup16,
  icoViewportsettings16,
  icoViewportsettings24,
  icoViewportsettings32,
  icoErrorDark16,
  icoErrorDark24,
  icoErrorDark32,
  icoEditUnavailable16,
  icoEditUnavailable24,
  icoEditUnavailable32,
  icoCircle16,
  icoAssignedToSelf16,
  icoAssignedToOther16,
  icoDictatingBySelf16,
  icoDictatingByOther16,
  icoDownloadUnavailable16,
  icoDownloadUnavailable24,
  icoDownloadUnavailable32,
  icoSpinner16,
  icoPatient16,
  icoPatient24,
  icoAiChat24
];
